import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { MECHANICAL_ASPECT_TYPE, MechanicalAspect } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class MechanicalAspectServiceBase extends CrudService<MechanicalAspect, number> {

  servicePath: string = '/mechanicalaspect';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, MECHANICAL_ASPECT_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<MechanicalAspect>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<MechanicalAspect>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



